import script from "./BaseStructuredPrayerList.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseStructuredPrayerList.vue?vue&type=script&setup=true&lang=js"

import "./BaseStructuredPrayerList.vue?vue&type=style&index=0&id=26ea466b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/prayerwall/prayerwall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26ea466b"]])

export default __exports__